import React from "react";
import ctl from "@netlify/classnames-template-literals";
import { Container, Text, Button } from "components";

const ExploreCard = ({
  title,
  image,
  description,
  buttonText,
  subTitle,
  pageLink,
}) => {
  return (
    <Container>
      <section className={sectionWrapperStyle}>
        <div className={textWrapperStyle}>
          <Text
            variant="p14"
            value={subTitle}
            color="secondary-1200"
            className="capitalize"
          />
          <Text variant="h2" value={title} color="secondary" />

          <Text
            variant="p18"
            value={description}
            color="secondary-1200"
            className="my-[26px]"
          />
          <Button
            hasArrow={true}
            size="medium"
            text={buttonText}
            variant="secondary-dark"
            to={pageLink || "/get-demo"}
          />
        </div>
        <div className={imageWrapperStyle}>{image}</div>
      </section>
    </Container>
  );
};

const sectionWrapperStyle = ctl(`
bg-secondary-200 
flex 
flex-col 
lg:flex-row
 mb-[94px] 
 justify-between
`);
const textWrapperStyle = ctl(`
pt-[33px] 
lg:pt-[107px]
 px-[26px] 
 lg:pr-0 
 lg:pl-[71px] 
 max-w-[589px]
`);
const imageWrapperStyle = ctl(`
lg:max-w-[503px]
mt-[31px] 
lg:mt-0
`);

export { ExploreCard };
